module.exports = __webpack_public_path__ + "img/hakimimg.53056d23.jpg";